var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.8675 7.6275C2.3775 8.1175 2.3775 8.9075 2.8675 9.3975L11.1775 17.7075C11.5675 18.0975 12.1975 18.0975 12.5875 17.7075L20.8975 9.3975C21.3875 8.9075 21.3875 8.1175 20.8975 7.6275C20.4075 7.1375 19.6175 7.1375 19.1275 7.6275L11.8775 14.8675L4.6275 7.6175C4.1475 7.1375 3.3475 7.1375 2.8675 7.6275Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.af02cdb4a53a05e3d0e4052e97dd164d.svg";
export { ForwardRef as ReactComponent };